<div class="d-flex flex-column gap-2">
  <div class="cov-fs-strong">{{ 'inquiries.sideDrawer.fileAttachments.label'|transloco }}</div>
  <div class="d-flex flex-column gap-2 cov-fs-muted">
    @for (file of files(); track file.name + file.size) {
      <div class="d-flex justify-content-between">
        <span>{{ file.name }}</span>
        <span class="file-size">{{ formatFileSize(file.size) }}</span>
        <cov-icon class="delete" [iconName]="IconName.DELETE" (click)="fileDeleted.emit(file)" />
      </div>
      <cov-divider />
    }
  </div>
</div>
